import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AuditLog } from '@shared/models/audit-log.model';
import { Pagination } from '@shared/models/pagination.model';
import { BaseService } from '@shared/services/base.service';
import { Observable } from 'rxjs';

import {
  SupplerPartnerCouponListContent,
  SupplierPartnerCouponCriteria,
  SupplierPartnerCouponProduct
} from '../models/supplier-partner-coupon.model';

@Injectable({
  providedIn: 'root'
})
export class SupplierPartnerCouponService extends BaseService {
  public override headers: HttpHeaders;

  constructor(private readonly http: HttpClient) {
    super();
    this.envService = this.env.services.supplierPartnerCoupon;
    this.headers = new HttpHeaders(this.envService.headers);
  }

  getSupplierPartnerCouponList(
    criteria: SupplierPartnerCouponCriteria
  ): Observable<Pagination<SupplerPartnerCouponListContent>> {
    const storeCode = this.retrieveStore().storeCode;
    const params = this.getParams(criteria);
    const url = this.getFullUrl(this.envService.list, {
      storeCode
    });

    return this.http.get<Pagination<any>>(url, {
      headers: this.loaderHeaders(null),
      observe: 'body',
      params
    });
  }

  getSupplierPartnerCouponView(_payload: any) {
    const url = this.getFullUrl(this.envService.view);
    return this.http.get<any>(url, {
      headers: this.loaderHeaders(null),
      observe: 'body',
      params: _payload
    });
  }

  getSupplierPartnerCouponHistory(_payload: any) {
    const url = this.getFullUrl(this.envService.history);
    return this.http.get<{ auditLogs: AuditLog[] }>(url, {
      headers: this.loaderHeaders(null),
      observe: 'body',
      params: _payload
    });
  }

  getSupplierPartnerCouponProduct(_payload: any) {
    const url = this.getFullUrl(this.envService.product);
    return this.http.get<Pagination<SupplierPartnerCouponProduct>>(url, {
      headers: this.loaderHeaders(null),
      observe: 'body',
      params: _payload
    });
  }
}
